import React, { useEffect, useState } from "react";
import { GetPreScreenTemplateResponseHelper } from "../../../ATSSettings/helper/AtsFormTemplateResponseHelper"
import { Box, Card, CardContent, Grid, IconButton, Skeleton, Typography } from "@mui/material";
import { getImageSignedUrl } from "../../../Base/helper/baseFunctions";
import { NoData } from "../../../Base/views/NotAuthorized";
import { useParams } from "react-router";
import { makeStyles } from "@mui/styles";
import UnauthorizedBase from "../../../Base/views/UnauthorizedBase";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";

const PreScreenResponses = () => {
    const { guid } = useParams();
    const decguid = atob(guid);
    const domain = decguid?.split("=")?.[1];
    const res_id = decguid?.split("=")?.[0];
    const useStyles = makeStyles({
        row: {
            padding:"20px 0px",
        },
        label: {
            fontSize: "0.75rem", fontWeight: 400, width: "400px", flexShrink: 0,
            color: "rgb(99, 115, 129)", height: "30px", lineHeight: "15px", margin: "4px 0px 4px 0px",paddingTop:"9px"
        },
        value: {
            display: "block", 
            marginTop:"30px", 
            padding:"5px 20px", 
            backgroundColor:"rgb(245, 245, 245)", 
            minHeight:"40px", 
            borderRadius:"4px",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
            whiteSpace: "pre-wrap"
        }
    });
    const [viewMode, setViewMode] = useState("loading")
    const [response, setResponse] = useState([]);
    const classes = useStyles()

    useEffect(() => {
        GetPreScreenTemplateResponseHelper({ workspace:domain , prescreening_response_id: res_id }).then((res) => {
            if (res?.data?.statuscode === 200) {
                setResponse(res?.data?.data)
                setViewMode("response")
            }
            else {
                setViewMode("not_found")
            }
        })
        //eslint-disable-next-line
    }, [])

    const formattedKey = (key) => {
        return key.replace(/_/g, ' ').replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
    };
  const handleView = async (filename, actionType = "preview", key) => {
    try {
      const url = await getImageSignedUrl(filename);
      if (actionType === "download") {
       const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = key || filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
        } else if (actionType === "preview") {
        if (['.doc', '.docx'].some(ext => filename.endsWith(ext))) {
          window.open(
            `https://docs.google.com/viewer?url=${encodeURIComponent(
              url
            )}&embedded=true`,
            "_blank"
          );
        } else if (['.xls', '.xlsx'].some(ext => filename.endsWith(ext))) {
          window.open(
            `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`,
            "_blank"
            );
        } else {
          window.open(url, "_blank");
        }
    }
      return url;
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };
    return (
        <UnauthorizedBase>
        <Box className="bg_form_main" sx={{minHeight:"90vh", paddingTop:"50px"}}>
            {viewMode === "loading" ?
                <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }} >
                    <Grid item xs={12} sm={12} md={12}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={2}>
                                    {Array(4)
                                        .fill()
                                        .map((data, index) => (
                                            <>
                                                <Grid item xs={12} sm={12} md={12} >
                                                    <Skeleton />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} >
                                                    <Skeleton width={120} />
                                                </Grid>
                                            </>))}
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                : viewMode === "response" ?
                <Box className="response-main"> 
                    {response?.map((row, rowIndex) => (
                        <Box className="response-content" key={rowIndex}>
                           <Box sx={{ padding: "40px 50px 40px" }}>
                            <Typography variant="h4" sx={{ paddingBottom:"20px", lineHeight:"30px"}}>{row?.prescreen_template_name}</Typography>
                                {Object.entries(row?.prescreen_response)?.map(([key, value], index) => (
                                    <Box item xs={12} sm={12} md={12} key={key}>
                                        <div>
                                        <div className={classes.row}>
                                            <span style={{ fontSize:"18px"}} className={classes.label}>{`${index + 1}. ${formattedKey(key)}`}</span>
                                            <div className={classes.value}>
                                                { value?.type === "file" ? (
                                                    <Box display={"flex"} alignItems={"center"} gap={"20px"}>
                                                        <span style={{ color: "blue", textDecoration: "none",cursor: 'pointer', '&:hover': { textDecoration: 'underline', cursor: 'pointer' } }} onClick={() => handleView(value?.value.replace(/"/g, ''), "download", key)}>
                                                            Download the Attachment
                                                        </span>
                                                        <IconButton onClick={(event) => handleView(value?.value.replace(/"/g, ''), "preview")}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </Box>
                                                ) : (
                                                    <div>{value?.value ? <TruncatedText text={(value?.value)} /> : "" }</div>
                                                )} 
                                            </div>
                                        </div>
                                        </div>
                                    </Box>
                                 ))}
                            </Box>
                        </Box>
                    ))}
                </Box>
                     : <NoData title="No Response Found" />
            }

        </Box>
        </UnauthorizedBase>
    )
}

export default PreScreenResponses;

const MAX_LENGTH = 95; // characters before truncating

const TruncatedText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;

  const isLong = text.length > MAX_LENGTH;
  const displayText = expanded ? text : text.slice(0, MAX_LENGTH) + (isLong ? "..." : "");

  return (
    <span style={{ lineHeight: "1.6" }}>
      {displayText}
      {isLong && (
        <span
          style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Show more"}
        </span>
      )}
    </span>
  );
};